const appConfig = {
  "name": "pfmla-v2-test",
  "version": "0.1.0",
  "stage": "test",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shd5478WH30vd697",
    "clientId": "51t117g0heqcaj50kvhllrn5ga",
    "redirectUris": [
      "https://hrfeeds-test.mit.edu",
      "https://hrfeeds.atlas-apps-test.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://hrfeeds-test.mit.edu/logout",
      "https://hrfeeds.atlas-apps-test.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/user",
      "email",
      "offline_access",
      "openid",
      "pfmla/export",
      "phone",
      "profile",
      "user/admin.pfml",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_nY154N4yV",
    "userPoolWebClientId": "51t117g0heqcaj50kvhllrn5ga",
    "oauth": {
      "domain": "atlas-auth-test.mit.edu",
      "scope": [
        "digital-id/user",
        "openid",
        "pfmla/export",
        "profile",
        "user/admin.pfml",
        "user/all"
      ],
      "redirectUris": [
        "https://hrfeeds-test.mit.edu",
        "https://hrfeeds.atlas-apps-test.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://hrfeeds-test.mit.edu/logout",
        "https://hrfeeds.atlas-apps-test.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;